<template>
  <div class="dashboard">
    <h1 class="page-title">Dashboard</h1>

    <div class="welcome-card">
      <h2>Selamat datang, {{ userName }}!</h2>
      <p>Kelola admin dan pengguna mobile dari dashboard ini.</p>
    </div>

    <a-row :gutter="16" class="stats-row">
      <a-col :span="12">
        <a-card :loading="loadingStats">
          <a-statistic
            title="Total Admin"
            :value="stats.totalAdmins"
          >
            <template #suffix>
              <a-icon type="user-add" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>

      <a-col :span="12">
        <a-card :loading="loadingStats">
          <a-statistic
            title="Total Users"
            :value="stats.totalUsers"
          >
            <template #suffix>
              <a-icon type="team" />
            </template>
          </a-statistic>
        </a-card>
      </a-col>
    </a-row>

    <a-row :gutter="16" class="quick-links">
      <a-col :span="12">
        <a-card hoverable @click="$router.push('/mobile-cms/admin-management')">
          <a-card-meta title="Admin Management" description="Kelola admin mobile">
            <template #avatar>
              <a-avatar icon="user-add" style="background-color: #1890ff" />
            </template>
          </a-card-meta>
        </a-card>
      </a-col>

      <a-col :span="12">
        <a-card hoverable @click="$router.push('/mobile-cms/user-management')">
          <a-card-meta title="User Management" description="Kelola pengguna mobile">
            <template #avatar>
              <a-avatar icon="team" style="background-color: #1890ff" />
            </template>
          </a-card-meta>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mobileCmsAdminAPI, mobileCmsUserAPI } from '@/services/axios/perki/mobileCms'

export default {
  name: 'MobileCmsDashboard',
  data() {
    return {
      loadingStats: false,
      stats: {
        totalAdmins: 0,
        totalUsers: 0,
      },
    }
  },
  computed: {
    userName() {
      const user = localStorage.getItem('mobile_cms_user')
      if (user) {
        try {
          const userData = JSON.parse(user)
          return userData.name || 'Admin'
        } catch {
          return 'Admin'
        }
      }
      return 'Admin'
    },
  },
  mounted() {
    this.loadStats()
  },
  methods: {
    async loadStats() {
      this.loadingStats = true
      try {
        const [adminsRes, usersRes] = await Promise.all([
          mobileCmsAdminAPI.getAll({ page: 1, pageSize: 1 }),
          mobileCmsUserAPI.getAll({ page: 1, pageSize: 1 }),
        ])
        this.stats.totalAdmins = adminsRes.data.result.total || 0
        this.stats.totalUsers = usersRes.data.result.total || 0
      } catch (error) {
        console.error('Failed to load stats:', error)
      } finally {
        this.loadingStats = false
      }
    },
  },
}
</script>

<style scoped>
.dashboard {
  padding: 0;
}

.page-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
}

.welcome-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.welcome-card h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
}

.welcome-card p {
  margin: 0;
  opacity: 0.9;
}

.stats-row {
  margin-bottom: 24px;
}

.quick-links {
  margin-top: 24px;
}

.quick-links .ant-card {
  cursor: pointer;
}

.quick-links .ant-card:hover {
  border-color: #1890ff;
}
</style>
